
<template>
  <div name="schools" class="page">



 <header class="inner-head">
      <div class="flex justify-between ">
        <h2 class="inner-head-title">Organisation Schools</h2>

      </div>
    </header>

    <div class="filter-bar">
        <ul class="actions">
           <li class="opacity-75">Search:</li>
        <li>
          <input
            type="search"
            class="          filter-bar-search focus:outline-none"
            name="search"
            v-model="search"
            placeholder="Enter search term..."
          />
        </li>
  
      </ul>
    </div>


    <p class="m-6 ml-8 pt-2 text-gray-500">{{filteredList.length}} schools in view
    </p>

  
                <noaccess v-if="!hasAccess" :blocktype="'outcome'"></noaccess>   

                   <table class="w-95p mx-auto mb-2 h-12 pt-2 align-text-bottom bg-white rounded text-left text-gray-400">
                              <thead>
                                <tr>
                                   <th class="w-9/12 pl-3">Name</th>
                                   <th class="w-1/12">Postcode</th>
                                  <th class="w-1/12">Active</th>
                                  <th class="w-1/12"></th>
                                </tr>
                              </thead>
                            </table>


                                   <table class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm" >
                              <tbody>
                                <tr v-for="item in filteredList" :key="item.id"> 
                                 
                                  <td class="w-9/12 pl-3">{{ item.name }} </td>
                                   <td class="w-1/12">{{ parsePostcode(item)}} </td>
                                   <td class="center w-1/12">
                                    <i class="icon list"  v-bind:class="setActiveClass(item.active)" />
                                   </td>
                                  <td class="tb-actions w-1/12">
                                       
                                  </td>
                                </tr>
  
                              </tbody>
                              <tfoot>

                              </tfoot>
                            </table>


  </div>


</template>

<script>
import { mapGetters } from "vuex";
import dropdown from "@/components/Dropdown.vue";

const noaccess = () => import("@/components/NoAccess.vue");
import { SchoolService } from "@/services/school.service";


export default {
  name: "schools",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess"
    }),
    activeDropdown() {
      this.selectedActive = this.actives[0];
      return this.actives;
    },
    orderedConsuls() {
      var vm = this;
      var active = vm.selectedActive.id;

      if (active == 2) {
        return _.orderBy(this.consuls, ["name"]);
      } else {
        var filtered = vm.consuls.filter(consul => {
          let filtered = true;

          if (filtered) {
            if (active < 2) {
              filtered = consul.active == active;
            }
          }

          return filtered;
        });
        return _.orderBy(filtered, ["name"]);
      }
    },
    filteredList() {
     return this.orderedConsuls.filter(item => {
       var vm = this;
       return item.name.toLowerCase().includes(vm.search.toLowerCase())
     })
   },
  },
  data() {
    return {
      errored: false,
      loading: false,
      hasAccess: false,
      actives: [
        { id: 2, name: "All" },
        { id: 1, name: "Active" },
        { id: 0, name: "Hidden" }
      ],
      selectedActive: {},
      consuls: [],
      selectedSchools:[],
      search: '',
      showReportModal: false
    };
  },
  created() {
    this.loading = true;
    this.hasAccess = this.currentUser.isSchool == false;
    this.fetchData();
  },
  methods: {
    fetchData() {
      SchoolService.getAll("consuls")
        .then(response => this.buildConsulList(response.data))
        .catch(err => {
          console.log("Consuls " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildConsulList(data) {
      this.consuls = data;
    },
    setActiveClass(active) {
      if (active == 1) {
        return "fas fa-check-circle true";
      } else {
        return "fas fa-times-circle false";
      }
    },
    showConsul(consul) {
      this.$router.push({ name: "SchoolEdit", params: { consul: consul } });
    },
    activeSelect(active) {
      this.selectedActive = active;
    },
    parsePostcode(consul) {
      return consul.postcode.Valid == true ? consul.postcode.String : "n/a"
    },

  },
  components: {
    dropdown,
    noaccess,
  }
};
</script>


<style scoped>

.button:disabled {
  @apply bg-gray-500 text-gray-400 cursor-not-allowed
}

</style>
